import { render } from "./new-user.vue?vue&type=template&id=ea764b28"
import script from "./new-user.vue?vue&type=script&lang=js"
export * from "./new-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__